module.exports = __webpack_public_path__ + "img/4-Phrase-icon.c3d42f35.svg";